// removed by extract-text-webpack-plugin
module.exports = {"root":"product-detail-modal--root--x_hSf1SZ","image":"product-detail-modal--image--1zT4zIEY","close":"product-detail-modal--close--1j0JjQ-s","variation":"product-detail-modal--variation--OKZTZ4ux","form-container":"product-detail-modal--form-container--1fB3wCfg","formContainer":"product-detail-modal--form-container--1fB3wCfg","disclaimer":"product-detail-modal--disclaimer--1j2i8GBT"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail-modal/styles.css
// module id = ./components/product-detail-modal/styles.css
// module chunks = 0